import { Back, Power4, TimelineLite } from 'gsap';

const Burger = new TimelineLite({
  paused: true,
  reversed: true,
});

Burger.to('.BurgerIcon__upper', 0.75, {
  ease: Back.easeInOut.config(1.7),
  rotation: 45,
  y: '10.12px',
  transformOrigin: 'center',
}, 0.25)
  .to('.BurgerIcon__middle', 1, {
    ease: Power4.easeInOut,
    opacity: 0,
    x: '-50%',
    transformOrigin: 'center',
  }, 0)
  .to('.BurgerIcon__lower', 0.75, {
    ease: Back.easeInOut.config(1.7),
    rotation: -45,
    y: '10.12px',

    transformOrigin: 'center',
  }, 0.25);

export default Burger;
